
import { defineComponent, ref, reactive, onMounted, toRefs, computed } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'

export default defineComponent({
    setup(){

        const store = useStore()
        const router = useRouter()
        const loading = ref(false)
        const current_page_active = ref(1)
        const current_page_inactive = ref(1)

        const fields = ref<any>([
            {
                title: 'Vendor ID',
                dataIndex: 'vendor_id',
            },
            {
                title: 'Vendor Name',
                dataIndex: 'vendor_name',
            },
            {
                title: 'Email',
                dataIndex: 'email',
            },
            {
                title: 'Address',
                dataIndex: 'address',
            },
            {
                title: 'Contact No',
                dataIndex: 'contact_no',
            },
            {
                title: 'Action',
                dataIndex: 'action',
                slots: {customRender: 'action'},
                align: 'center'
            }
        ])

        const active = ref([])
        const inactive = ref([])

        const loadActive = (payload = {page: 1, is_active: true}) => {
            payload.page = current_page_active.value;
            store.dispatch('Vendor/index', payload).then((res:any) => {
                active.value = res.data
                if(current_page_active.value > res.data.last_page) {
                    current_page_active.value = res.data.last_page
                    loadActive()
                }
            })
        }

        const loadInactive = (payload = {page: 1,  is_active: false}) => {
            payload.page = current_page_inactive.value;
            store.dispatch('Vendor/index', payload).then((res:any) => {
                inactive.value = res.data
                if(current_page_inactive.value > res.data.last_page) {
                    current_page_inactive.value = res.data.last_page
                    loadActive()
                }
            })
        }

        const activate = (record:any) => {
            loading.value = true
            store.dispatch('Vendor/activate', record.id).then(() => {
                loading.value = false
                loadActive();
                loadInactive();
            })
        }

        const filterRecordActive = (payload: any) => {
            current_page_active.value = payload.page
            payload = {
                page: payload.page,
                search: payload.search,
                is_active: true,
            };
            store.dispatch("Vendor/index", payload).then((res:any) => {
                active.value = res.data
            })
        }

        const filterRecordInactive = (payload: any) => {
            current_page_inactive.value = payload.page
            payload = {
                page: payload.page,
                search: payload.search,
                is_active: false,
            };
            store.dispatch("Vendor/index", payload).then((res:any) => {
                inactive.value = res.data
            })
        }
        
        onMounted(() => {
            loading.value = false
            loadActive()
            loadInactive()
        })

        
        return {
            fields,
            loading,
            active,
            inactive,
            activate,
            filterRecordActive,
            filterRecordInactive
        }
    }
});

